/* sts-collection.js - see docs/new-theme-v4/asset-notes/sts-collection.md
   for what this file is, what it is NOT responsible for, and the six jobs
   it does. Read that before changing a card verdict or the grid swap. */
(function (w, d) {
  'use strict';

  /* One run per page: sts-product-row adds this file once per row (CP-11). */
  if (w.STS && w.STS.collectionBooted) return;
  (w.STS = w.STS || {}).collectionBooted = true;

  /* moved: asset-notes/sts-collection.md ("sts-collection.js", The verdict rule itself) */
  function fit() { return w.STS && w.STS.fit; }

  /* ------------------------------------------------------------------ util */
  function store(kind) {
    return {
      get: function (k) { try { return w[kind].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { w[kind].setItem(k, v); return true; } catch (e) { return false; } }
    };
  }
  var ls = store('localStorage');
  var ss = store('sessionStorage');

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function json(el, attr) {
    if (!el) return null;
    var raw = attr ? el.getAttribute(attr) : el.textContent;
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function myType() {
    var s = w.STS && w.STS.state;
    return (s && s.type) || null;
  }

  /* Analytics (spec 09 §6.9). Every call goes through window.stsTrack, which
     owns consent and the ad gate; nothing here ever talks to a pixel. */
  function track(name, params) {
    try { if (typeof w.stsTrack === 'function') w.stsTrack(name, params); } catch (e) { /* never break a page */ }
  }
  function quizClick(placement, href, kind) {
    try {
      var T = w.STSTrack;
      if (T && typeof T.quizClick === 'function') return T.quizClick(placement, href, kind);
    } catch (e) { /* never break a page */ }
    return false;
  }
  function collectionHandle() {
    var m = /\/collections\/([^\/?#]+)/.exec(w.location.pathname);
    return m ? decodeURIComponent(m[1]) : null;
  }
  /* §6.9 event 35's reason: the HTTP status the fetch rejected with, or the
     error's own short message ("no section", "Failed to fetch"). */
  function failReason(err) {
    if (typeof err === 'number') return 'http_' + err;
    if (err && err.name === 'AbortError') return 'timeout';
    return String((err && err.message) || 'fetch').slice(0, 40);
  }
  /* moved: asset-notes/sts-collection.md ("leaving the page") */
  function failed(slot, err, fallback) {
    var T = w.STSTrack, gone = function () { return w.document !== d || !!(T && T.leaving && T.leaving()); };
    if (gone()) return;
    w.setTimeout(function () {
      if (gone()) return;
      track('sts_slot_failed', { slot: slot, reason: failReason(err) });
      fallback();
    }, err instanceof TypeError ? 1000 : 0);
  }

  /* Every fetch has a deadline: see docs/new-theme-v4/asset-notes/sts-collection.md
     ("fetch deadline"). */
  var NET_TIMEOUT_MS = 8000;

  function fetchWithTimeout(url, opts, ms) {
    var ctrl = typeof w.AbortController === 'function' ? new w.AbortController() : null;
    var o = Object.assign({}, opts || {});
    if (ctrl) o.signal = ctrl.signal;
    var timer = w.setTimeout(function () {
      if (ctrl) { try { ctrl.abort(); } catch (e) { /* already gone */ } }
    }, ms || NET_TIMEOUT_MS);
    /* No AbortController (very old engines): the timer still rejects, so the
       caller is never left waiting even though the socket stays open. */
    var deadline = ctrl ? null : new Promise(function (_, reject) {
      w.setTimeout(function () { reject(new Error('timeout')); }, ms || NET_TIMEOUT_MS);
    });
    /* Plain window.fetch on purpose: shop_events_listener wraps it, and that
       is the only source of product_added_to_cart. See layout/theme.liquid. */
    var req = window.fetch(url, o);
    var race = deadline ? Promise.race([req, deadline]) : req;
    return race.then(
      function (r) { w.clearTimeout(timer); return r; },
      function (e) { w.clearTimeout(timer); throw e; }
    );
  }

  /* ------------------------------------------------------- guest verdicts */
  /* moved: asset-notes/sts-collection.md ("sts-collection.js", The verdict for a card the server) */
  /* Re-run on every type change (the simulator, a quiz retake), so a card is
     stamped with the type JS resolved it for (data-sts-js) and skipped while
     that still holds. A card the server decided is left alone until the type
     differs from the one the page loaded with (T0). With no type, cards JS
     resolved go back to "unknown". */
  var T0;
  function resolveCards(root, reasons) {
    var FIT = fit();
    if (!FIT) return;
    var type = myType();
    if (T0 === undefined && type) T0 = type;
    var wanted = type && FIT.wantedSubs();
    $$('[data-sts-card]', root).forEach(function (card) {
      /* A Shop by any skin type card is for THEIR type (for_type), never the viewer's. */
      if (card.hasAttribute('data-sts-for')) return;
      var was = card.getAttribute('data-sts-js');
      if (was === (type || null)) return;
      if (!type) { if (was === null) return; }
      else if (was === null && card.getAttribute('data-sts-fit') !== 'unknown' && type === T0) return;
      var approved = (card.getAttribute('data-sts-approved') || '').split(/\s+/).filter(Boolean);
      var sens = (card.getAttribute('data-sts-sens') || '').split(/\s+/).filter(Boolean);
      var v = type ? FIT.verdict(approved, sens, type, wanted) : { fit: 'unknown', letter: '', missing: [] };
      var off = v.fit === 'barred' || v.fit === 'subtype';
      var sentence = '';

      if (v.fit === 'barred') {
        /* v6.2 §11: the product's own note first (data-sts-notes). */
        sentence = ownNote(card, v.letter) || (reasons && (reasons[v.letter] || reasons['*'])) ||
          'Dr. Baumann has not approved this product for your Baumann Skin Type.';
      } else if (v.fit === 'subtype') {
        sentence = 'Not approved for the ' + v.missing.join(', ') + '-prone form of sensitive skin.';
      }

      if (v.fit === 'barred') card.setAttribute('data-sts-bar', v.letter);
      else card.removeAttribute('data-sts-bar');
      card.setAttribute('data-sts-fit', v.fit);
      if (type) card.setAttribute('data-sts-js', type);
      else card.removeAttribute('data-sts-js');
      var slot = $('[data-sts-reason]', card);
      if (slot) slot.textContent = sentence;
      var prop = $('[data-sts-not-for-type]', card);
      if (prop) nft(prop, off ? type : '');
    });
  }

  function ownNote(el, letter) {
    try { return (JSON.parse(el.getAttribute('data-sts-notes') || '{}') || {})[letter] || ''; } catch (e) { return ''; }
  }

  /* moved: asset-notes/sts-collection.md ("A card outside a collection root") */
  function settle(card) {
    if (card) resolveCards(card.parentNode, json($('[data-sts-reasons]')));
  }

  /* -------------------------------------------- count line, toggle, strips */
  function personalise(root) {
    var type = myType();
    var filters = $('[data-sts-filters]', root);
    var collectionType = root.getAttribute('data-collection-type') || '';

    $$('[data-sts-my-type]', root).forEach(function (el) {
      if (type) el.textContent = type;
    });

    if (type) {
      var urls = filters ? json(filters, 'data-fits-urls') : null;
      var rt = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
      var line = $('[data-sts-count-typed]', root);
      /* The filter's one type (data-fits-code). Someone else's is named as
         theirs, gets the strip and no toggle (its link would OR the two). */
      var fc = (line && line.getAttribute('data-fits-code')) || '';

      /* Two toggles, the phone and desktop copies (COL-3). On the shopper's own
         type collection every product is approved, so a toggle would be a
         control that changes nothing. Spec §7.1 removes it. */
      (filters ? $$('[data-sts-fits-toggle]', filters) : []).forEach(function (toggle) {
        if ((collectionType && collectionType === type) || (fc && fc !== type)) toggle.parentNode.removeChild(toggle);
        /* Signed in, Liquid baked the account's type; a newer quiz wins. */
        else if (urls && urls[type] && !filters.hasAttribute('data-fits-active')) toggle.setAttribute('href', urls[type]);
      });

      var counts = json(root, 'data-type-counts');
      var on = filters && filters.hasAttribute('data-fits-active');
      var out = sensOut(root, (on && (fc || type) === type) || collectionType === type);
      if (line) {
        var n = parseInt(root.getAttribute('data-count'), 10) || 0;
        if (out && !$('[data-sts-pager]', root)) n = Math.max(0, n - out);
        /* Pluralised on both pages, as the prototype's colCountLine is (COL-1);
           the Liquid lines in both sections land on the same words. */
        var w1 = n === 1 ? ' product' : ' products';
        if (on || collectionType === type) {
          line.textContent = n + w1 + ', all approved for ' + (fc || type) + '.';
        } else if (counts && typeof counts[type] === 'number') {
          line.textContent = n + w1 + '. ' + counts[type] +
            (counts[type] === 1 ? ' is' : ' are') + ' right for your skin type.';
        }
      }

      /* "You are DSPW. See the products for your type →" — only on someone
         else's type (collection or filter); the link is sts-skin-types shop_url.
         The row's height is reserved in CSS, so un-hiding it here cannot push
         the grid down. */
      var strip = $('[data-sts-strip-other]', root), other = collectionType || fc;
      if (strip && other && other !== type) {
        var link = $('[data-sts-my-type-url]', strip);
        if (link) link.setAttribute('href', rt + 'collections/all?filter.p.m.product_info.baumann_skin_type_info=' + type);
        strip.hidden = false;
      }

      /* The "see all my approved products" escape from the empty state: the same
         approval filter, moved onto the all-products collection. Built from this
         collection's own url_to_add so the query string is whatever Search &
         Discovery actually publishes, never a guessed param name. */
      var seeAll = $('[data-sts-see-all]', root);
      if (seeAll && urls && urls[type]) {
        var q = urls[type].split('?')[1];
        var allUrl = rt + 'collections/all';
        seeAll.setAttribute('href', q ? allUrl + '?' + q : allUrl);
      }
    } else sensOut(root, false);

    /* After a Section Rendering swap this is what flags the new cards. */
    flagCards(root);
  }

  /* Approved-only hides a sensitivity mismatch as it hides a type one (note
     03): asset-notes/sts-collection.md ("sensOut"). Returns the count hidden. */
  var SENS_OUT = '[data-sts-grid] > [data-sts-card][data-sts-fit="subtype"]:not([data-sts-for])';
  function sensOut(root, on) {
    if (on) root.setAttribute('data-sts-sens-out', '');
    else root.removeAttribute('data-sts-sens-out');
    return on ? $$(SENS_OUT, root).length : 0;
  }

  /* ------------------------------------------------------ applied filters */
  /* Chips the server could not draw: asset-notes/sts-collection.md ("client chips"). */
  var PRICE_PARAMS = ['filter.v.price.gte', 'filter.v.price.lte'];

  /* One filter value, named the same way whether it came from the server's chip
     attributes or from the query string. Both halves are encoded so a value that
     happens to contain the separator cannot collide with another param. */
  function chipKey(param, value) {
    return encodeURIComponent(param || '') + '&' + encodeURIComponent(value || '');
  }

  function isTypeParam(filters, name) {
    var tp = filters && filters.getAttribute('data-type-param');
    if (tp && name === tp) return true;
    return name.indexOf('baumann_skin_type') > -1;
  }

  /* `filter.p.m.product_info.baumann_skin_type_info` -> "Baumann skin type". Only
     ever used when the value itself is unreadable (a metaobject gid), because the
     value is what the shopper picked and the param is only what it was stored under. */
  function prettyParam(name) {
    var tail = name.replace(/^filter\.[pv]\.(m\.)?/, '').split('.').pop();
    tail = tail.replace(/[_-]+/g, ' ').replace(/ (object|info)$/, '').trim();
    if (tail === 'item type') tail = 'product type';
    return tail ? tail.charAt(0).toUpperCase() + tail.slice(1) : 'Filter';
  }

  /* Clear filters keeps the skin-type filter; at zero results only the URL has it. */
  function keepFits(root, href) {
    var u = new URL(href, w.location.href), f = $('[data-sts-filters]', root);
    new URLSearchParams(w.location.search).forEach(function (v, k) {
      if (isTypeParam(f, k) && u.searchParams.getAll(k).indexOf(v) < 0) u.searchParams.append(k, v);
    });
    return u.pathname + u.search;
  }

  function withoutParam(key, value) {
    var p = new URLSearchParams(w.location.search);
    var keys = key === 'filter.v.price' ? PRICE_PARAMS : [key];
    keys.forEach(function (k) {
      var kept = p.getAll(k).filter(function (v) { return value === null || v !== value; });
      p.delete(k);
      kept.forEach(function (v) { p.append(k, v); });
    });
    var qs = p.toString();
    return w.location.pathname + (qs ? '?' + qs : '');
  }

  /* The same chip the snippet draws: the × and the visually-hidden name are a fixed
     string, and the label — the only part that comes from the URL — goes in as a
     text node, so nothing a query string carries is ever parsed as markup. */
  var CHIP_TAIL =
    '<svg class="sts-ico" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" d="M5 5l14 14M19 5L5 19"/></svg>' +
    '<span class="sts-vh">Remove filter</span>';

  function buildChip(label, href, isType) {
    var a = d.createElement('a');
    a.className = 'sts-chip';
    a.setAttribute('href', href);
    a.setAttribute('data-sts-chip', '');
    a.setAttribute('data-sts-chip-js', '');
    if (isType) a.setAttribute('data-sts-fits-chip', '');
    a.innerHTML = CHIP_TAIL;
    a.insertBefore(d.createTextNode(label), a.firstChild);
    return a;
  }

  function syncChips(root) {
    var box = $('[data-sts-chips]', root);
    if (!box || typeof w.URLSearchParams !== 'function') return;
    var filters = $('[data-sts-filters]', root);

    $$('[data-sts-chip-js]', box).forEach(function (el) { el.parentNode.removeChild(el); });

    /* What the server already drew, so nothing is chipped twice. */
    var seen = {};
    $$('[data-sts-chip]', box).forEach(function (el) {
      seen[chipKey(el.getAttribute('data-param'), el.getAttribute('data-value') || '')] = true;
    });

    var params = new URLSearchParams(w.location.search);
    var priceDone = seen[chipKey('filter.v.price', '')];
    var keys = [];
    params.forEach(function (_, k) { if (keys.indexOf(k) === -1) keys.push(k); });
    /* Ahead of Clear filters, which ends the row. */
    var clear = $('[data-sts-clear]', box);
    function add(chip) { box.insertBefore(chip, clear); }

    keys.forEach(function (key) {
      if (key.indexOf('filter.') !== 0) return;
      if (PRICE_PARAMS.indexOf(key) > -1) {
        if (priceDone) return;
        priceDone = true;
        add(buildChip('Price', withoutParam('filter.v.price', null), false));
        return;
      }
      params.getAll(key).forEach(function (value) {
        if (seen[chipKey(key, value)]) return;
        var isType = isTypeParam(filters, key);
        var opaque = /^gid:\/\//.test(value);
        /* moved: asset-notes/sts-collection.md ("The `_info` field stores") */
        var label = isType
          ? (opaque ? 'Skin type' : 'Approved for ' + value)
          : key === 'filter.v.availability'
            ? (value === '1' ? 'In stock' : 'Out of stock')
            : (opaque ? prettyParam(key) : value);
        add(buildChip(label, withoutParam(key, value), isType));
      });
    });
  }

  /* ------------------------------------------------ profile flags (04-W64) */
  /* Liked-brand and over-budget flags: asset-notes/sts-collection.md ("profile flags"). */
  function profileTag(mod, text, star) {
    var el = d.createElement('span');
    el.className = 'sts-tag sts-tag--' + mod;
    if (star) {
      var s = d.createElement('span');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '★';
      el.appendChild(s);
    }
    el.appendChild(d.createTextNode(text));
    return el;
  }

  function flagCards(root) {
    var S = w.STS;
    var p = S && S.profileReady ? S.profile : null;
    if (!p) return;
    var liked = (p.likedBrands || []).map(function (b) { return String(b).toLowerCase(); });
    var budget = parseInt(p.budgetCents, 10) || 0;
    $$('[data-sts-card]', root).forEach(function (card) {
      var slot = $('[data-sts-pflags]', card);
      if (!slot) return;
      var brand = (card.getAttribute('data-sts-brand') || '').toLowerCase();
      var price = parseInt(card.getAttribute('data-sts-price'), 10) || 0;
      var isLiked = !!brand && liked.indexOf(brand) > -1 && !card.hasAttribute('data-sts-liked');
      var isOver = budget > 0 && price > budget && !card.hasAttribute('data-sts-over-budget');
      var key = (isLiked ? 'liked' : '') + (isOver ? ' over' : '');
      if (slot.getAttribute('data-sts-pflags') === key) return;
      slot.setAttribute('data-sts-pflags', key);
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      if (isLiked) slot.appendChild(profileTag('liked', 'Brand you like', true));
      if (isOver) slot.appendChild(profileTag('warn', 'Over your budget'));
    });
  }

  /* -------------------------------------------------- Section Rendering API */
  var busy = false;

  function sectionUrl(url, id) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
  }

  /* Carry utm_*, code, sts_preview etc. across a swap; filters, sort and page
     come from the link itself. */
  function keepParams(url) {
    var u = new URL(url, w.location.href);
    new URLSearchParams(w.location.search).forEach(function (v, k) {
      if (!/^(filter\.|sort_by$|page$|q$|type$)/.test(k) && !u.searchParams.has(k)) u.searchParams.append(k, v);
    });
    return u.pathname + u.search;
  }
  /* The section's HTML for a URL: the swap below, and the Filters panel's
     "Show N results" count (assets/sts-filter-panel.js), whose HTML the swap
     then reuses (opts.html) rather than asking twice. */
  function getSection(root, url) {
    return fetchWithTimeout(sectionUrl(keepParams(url), root.getAttribute('data-section-id')), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); });
  }
  function applyUrl(root, url, opts) {
    opts = opts || {};
    url = keepParams(url);
    if (busy) return;
    /* The shopper taking approved-only (this page) or In stock (the session)
       off is a "no": remembered, or the default puts it straight back. */
    if (!opts.auto) {
      var was = w.location.search, next = url.split('?')[1] || '';
      if (hasFits(was) && !hasFits(next)) ss.set(fitsKey(), '1');
      if (/filter\.v\.availability/.test(was) && !/filter\.v\.availability/.test(next)) ss.set('sts_instock_only', '0');
    }
    busy = true;
    root.setAttribute('aria-busy', 'true');
    return (opts.html ? Promise.resolve(opts.html) : getSection(root, url))
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sts-collection]');
        if (!fresh) throw new Error('no section');
        ['data-count', 'data-type-counts', 'data-kind', 'data-collection-type'].forEach(function (a) {
          if (fresh.hasAttribute(a)) root.setAttribute(a, fresh.getAttribute(a));
          else root.removeAttribute(a);
        });
        closeSheet();
        root.innerHTML = fresh.innerHTML;
        if (opts.replace) w.history.replaceState({ sts: 1 }, '', url);
        else w.history.pushState({ sts: 1 }, '', url);
        busy = false;
        root.removeAttribute('aria-busy');
        wire(root);
        if (!opts.keepScroll) {
          var grid = $('[data-sts-grid], [data-sts-empty]', root);
          /* A jump, not a glide up from the old page (v6.2 §1.3). */
          var up = function () { grid.scrollIntoView({ block: 'start' }); };
          if (grid && grid.getBoundingClientRect().top < 0) { if (w.STS.scroll) w.STS.scroll.now(up); else up(); }
        }
      })
      .catch(function (err) {
        /* Anything at all goes wrong and the browser does what it would have
           done without this file: follow the link. */
        busy = false;
        failed('collection_grid', err, function () { w.location.assign(url); });
      });
  }

  /* ------------------------------------------------------------ the sheet */
  var openPanel = null, openPill = null, panelHome = null, scrim = null, lastFocus = null;

  function sheetHost() {
    var host = $('.sts-sheet-host');
    if (!host) {
      host = d.createElement('div');
      host.className = 'sts-sheet-host';
      d.body.appendChild(host);
    }
    return host;
  }

  /* Why the background goes inert: asset-notes/sts-collection.md ("filter sheet"). */
  var CAN_INERT = 'inert' in HTMLElement.prototype;
  function inertBehind(host, on) {
    if (!CAN_INERT || !host) return;
    var kids = d.body.children, i, k;
    for (i = 0; i < kids.length; i++) {
      k = kids[i];
      if (k === host || k.tagName === 'SCRIPT' || k.tagName === 'STYLE' || k.tagName === 'LINK') continue;
      if (on) {
        if (k.inert || k.hasAttribute('data-sts-sheet-inert')) continue;
        k.inert = true;
        k.setAttribute('data-sts-sheet-inert', '');
      } else if (k.hasAttribute('data-sts-sheet-inert')) {
        k.inert = false;
        k.removeAttribute('data-sts-sheet-inert');
      }
    }
  }

  function closeSheet() {
    if (!openPanel) return;
    var p = openPanel;
    /* Before the panel moves home, or it lands inside a subtree still inert. */
    inertBehind($('.sts-sheet-host'), false);
    openPanel.hidden = true;
    openPanel.classList.remove('sts-fpanel--sheet');
    if (panelHome && panelHome.parentNode) panelHome.parentNode.insertBefore(openPanel, panelHome);
    if (scrim && scrim.parentNode) scrim.parentNode.removeChild(scrim);
    if (openPill) openPill.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    openPanel = null; openPill = null; panelHome = null; scrim = null; lastFocus = null;
    /* Every way out (x, scrim, Escape) lands here: the Filters panel applies its ticks. */
    if (p.stsOnClose) p.stsOnClose();
  }

  /* One panel for every filter at every width since the Filters button
     (2026-09-29): a bottom sheet, a side drawer from 861px. Relocated, because a
     fixed panel is re-anchored by any transformed ancestor; moving the node to
     a host at the end of <body> is the only version that cannot be broken by
     CSS this file does not own. */
  function openSheet(pill, panel) {
    closeSheet();
    lastFocus = pill;
    openPill = pill;
    openPanel = panel;
    pill.setAttribute('aria-expanded', 'true');
    panelHome = d.createComment('sts-fpanel');
    panel.parentNode.insertBefore(panelHome, panel);
    scrim = d.createElement('div');
    scrim.className = 'sts-sheet-scrim';
    scrim.addEventListener('click', closeSheet);
    var host = sheetHost();
    host.appendChild(scrim);
    host.appendChild(panel);
    panel.classList.add('sts-fpanel--sheet');
    panel.hidden = false;
    inertBehind(host, true);
    var first = panel.querySelector('a[href], button');
    if (first) first.focus();
  }

  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null || n === d.activeElement; });
  }

  d.addEventListener('keydown', function (e) {
    if (!openPanel) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab' || openPanel.classList.contains('sts-fpanel--sheet') === false) return;
    var list = focusables(openPanel);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* A width change only: a phone's toolbar resizes the height as it scrolls. */
  var lastW = w.innerWidth;
  w.addEventListener('resize', function () { if (w.innerWidth !== lastW) { lastW = w.innerWidth; closeSheet(); } });

  /* For assets/sts-filter-panel.js: the swap, the section fetch and the sheet. */
  w.STS.coll = { apply: applyUrl, get: getSection, open: openSheet, close: closeSheet };

  /* -------------------------------------------------------------- modals */
  function showDialog(dlg) {
    /* Remembered on both paths. showModal() restores focus itself on close, but
       the fallback below is a plain [open] <dialog> — the browser does nothing
       for it, so focus was left on a button inside a node this file then
       removes from the document, which drops the caret back to <body>. */
    dlg.__opener = d.activeElement;
    if (typeof dlg.showModal === 'function') { dlg.showModal(); return; }
    /* Engines without showModal: pin it, scrim it, and keep the same close path.
       showModal() would also have supplied aria-modal, the Escape key and the
       Tab trap; none of that comes with [open], so all three are wired here. */
    dlg.classList.add('sts-modal--fallback');
    dlg.setAttribute('open', '');
    dlg.setAttribute('aria-modal', 'true');
    var s = d.createElement('div');
    s.className = 'sts-modal-scrim';
    s.addEventListener('click', function () { hideDialog(dlg); });
    d.body.appendChild(s);
    dlg.__scrim = s;
    dlg.__keys = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        /* Same exit as the native path, which fires `cancel` then `close`. */
        dlg.dispatchEvent(new Event('cancel'));
        hideDialog(dlg);
        if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables(dlg);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (d.activeElement === first || !dlg.contains(d.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && d.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    };
    d.addEventListener('keydown', dlg.__keys, true);
    var first = dlg.querySelector('a[href], button');
    if (first) first.focus();
  }
  function hideDialog(dlg) {
    var opener = dlg.__opener;
    dlg.__opener = null;
    if (typeof dlg.close === 'function' && dlg.open && !dlg.__scrim) { dlg.close(); return; }
    dlg.removeAttribute('open');
    dlg.removeAttribute('aria-modal');
    if (dlg.__keys) { d.removeEventListener('keydown', dlg.__keys, true); dlg.__keys = null; }
    if (dlg.__scrim && dlg.__scrim.parentNode) dlg.__scrim.parentNode.removeChild(dlg.__scrim);
    dlg.__scrim = null;
    if (opener && opener.focus && d.contains(opener)) opener.focus();
  }

  function confirmDialog(text, onYes, onNo, sub) {
    var dlg = d.createElement('dialog');
    dlg.className = 'sts-modal';
    /* A <dialog> has role="dialog" but no accessible name of its own, so this
       was reaching a screen reader as an unnamed "dialog". The heading is
       already the name; aria-labelledby just says so. The id is unique because
       only one of these is ever in the document at a time, but it is suffixed
       anyway so a stray leftover cannot shadow it. */
    var titleId = 'sts-fit-modal-title-' + (Date.now() % 100000);
    dlg.setAttribute('aria-labelledby', titleId);
    dlg.innerHTML =
      '<div class="sts-modal__inner">' +
      '<h2 class="sts-modal__title" id="' + titleId + '">' + (sub ? 'Not recommended for your sensitivity' : 'Not for your skin type') + '</h2>' +
      '<p class="sts-modal__body"></p>' +
      '<button type="button" class="sts-btn sts-btn--solid sts-btn--block" data-yes>Add to cart anyway</button>' +
      '<button type="button" class="sts-btn sts-btn--ghost sts-btn--block" data-no>No thanks</button>' +
      '</div>';
    /* v6.2 §11: the note is Dr. Baumann's reason and nothing after it. */
    $('.sts-modal__body', dlg).textContent = text || 'Dr. Baumann has not approved this product for your Baumann Skin Type.';
    d.body.appendChild(dlg);
    /* v6.1 1.2: ! octagon, the reason behind "Note from Dr. Baumann ▾". */
    var P = w.STS && w.STS.popups;
    if (P && P.notFor) { P.notFor($('.sts-modal__title', dlg), $('.sts-modal__body', dlg)); $('[data-yes]', dlg).autofocus = true; }
    function done() { hideDialog(dlg); if (dlg.parentNode) dlg.parentNode.removeChild(dlg); }
    $('[data-yes]', dlg).addEventListener('click', function () { done(); onYes(); });
    $('[data-no]', dlg).addEventListener('click', function () { done(); if (onNo) onNo(); });
    dlg.addEventListener('cancel', function () { if (onNo) onNo(); });
    dlg.addEventListener('close', function () { if (dlg.parentNode) dlg.parentNode.removeChild(dlg); });
    showDialog(dlg);
  }

  /* --------------------------------------------------------------- cart */
  /* `_sts_src` (spec 09 §3.7) names where the line came from. It is written
     into the form as a hidden input rather than only into the FormData, so the
     ordinary form post this falls back to carries it too. */
  function setSource(form, src) {
    var input = form.querySelector('input[name="properties[_sts_src]"]');
    if (!input) {
      input = d.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_sts_src]';
      form.appendChild(input);
    }
    input.value = src;
  }

  /* moved: asset-notes/sts-collection.md ("`sts:cart:updated` is the theme") */
  function announceCart() {
    /* Capped like every other request here. It runs after the quick-add button
       has already been released, so a hang strands nobody - but an uncapped
       promise on a long-lived page is a leak, and the header count it feeds is
       better wrong-and-settled than pending forever. */
    return fetchWithTimeout('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        var detail = { cart: cart };
        d.dispatchEvent(new CustomEvent('sts:cart:updated', { detail: detail }));
        d.dispatchEvent(new CustomEvent('theme:cart:change', { detail: detail }));
        return cart;
      })
      .catch(function () { return null; });
  }

  /* `_sts_src` names the surface: a row or sale section says which with
     data-sts-src (home, row, sale); a collection or search grid has none. */
  function srcOf(el, kind) {
    var h = el && el.closest('[data-sts-src]');
    return (h ? h.getAttribute('data-sts-src') : 'collection') + kind;
  }

  /* An empty line property is disabled so the form omits it. */
  function nft(el, v) { el.value = v; el.disabled = !v; }
  function addToCart(form, btn, src) {
    setSource(form, src || srcOf(form, '_quick_add'));
    var body = new FormData(form);
    btn.setAttribute('aria-busy', 'true');
    /* Timed for the same reason as the grid swap: without it a hung request
       leaves the button spinning and the shopper with no way to buy. The catch
       below already knows what to do — post the form the old way. */
    return fetchWithTimeout('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
      .then(function (item) {
        btn.removeAttribute('aria-busy');
        /* No "added to cart" toast (v5.1 §1.5): the cart count confirms it. */
        /* `sts:cart:added` carries the ONE line that was just added, for a
           surface that wants to react to that product (an upsell, a fit note).
           It is not a cart-state event and never was: the header count, the
           free-shipping bar and the drawer need the whole cart, which is why
           the quick-add also announces below. Kept as the per-line hook. */
        d.dispatchEvent(new CustomEvent('sts:cart:added', { detail: item }));
        return announceCart();
      })
      .catch(function () {
        /* Never leave the shopper stuck on a card that will not buy: hand the
           purchase back to the ordinary form post. */
        btn.removeAttribute('aria-busy');
        form.submit();
      });
  }

  /* --------------------------------------------------------- quick view */
  /* moved: asset-notes/sts-collection.md ("View Options" on a multi-variant card) */
  var qvCache = {};
  var qvDialog = null;

  function qvClose() {
    var dlg = qvDialog;
    if (!dlg) return;
    qvDialog = null;
    hideDialog(dlg);
    if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
  }

  /* The popup's own controls, wired once the fragment has landed. */
  function qvWire(dlg, card) {
    var box = $('[data-sts-qv]', dlg);
    if (!box) return;
    var form = $('[data-sts-qv-form]', dlg);
    var idInput = $('[data-sts-qv-id]', dlg);
    var add = $('[data-sts-qv-add]', dlg);
    var anyway = $('[data-sts-qv-anyway]', dlg);
    var img = $('[data-sts-qv-img]', dlg);
    var reasonSlot = $('[data-sts-qv-reason]', dlg);

    /* Inherited, not recomputed — see the note above. assets/sts-collection.css
       reveals Add to cart or "Buy it anyway" off this one attribute, exactly as
       it does on the card, so the popup cannot offer a plain Add for a product
       the card is barring two inches away. */
    var verdict = (card && card.getAttribute('data-sts-fit')) || '';
    box.setAttribute('data-sts-fit', verdict);
    if (reasonSlot && card && (verdict === 'barred' || verdict === 'subtype')) {
      var cardReason = $('[data-sts-reason]', card);
      if (cardReason) reasonSlot.textContent = (cardReason.textContent || '').trim();
    }

    var chips = $$('[data-sts-qv-chip]', dlg);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-sts-qv-chip');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        if (idInput) idInput.value = id;
        /* Every variant's price line is already in the fragment; choosing one
           is moving the `hidden` attribute, never formatting money in here. */
        $$('[data-sts-qv-price-for]', dlg).forEach(function (p) {
          if (p.getAttribute('data-sts-qv-price-for') === id) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
        var src = chip.getAttribute('data-img');
        if (img && src) img.src = src;
        /* A sold-out size is still choosable — hiding it would leave a shopper
           wondering whether the shade exists — but it cannot be bought, and the
           button has to say which of the two it is. */
        var out = chip.getAttribute('data-sold-out') === 'true';
        if (add) { add.disabled = out; add.textContent = out ? 'Sold out' : 'Add to cart'; }
        if (anyway) { anyway.disabled = out; anyway.textContent = out ? 'Sold out' : 'Add to cart anyway'; }
      });
    });

    if (add && form) {
      add.addEventListener('click', function (e) {
        e.preventDefault();
        qvSmall(box, idInput, function () { addToCart(form, add, srcOf(card, '_quick_view')).then(qvClose); });
      });
    }

    /* The same confirm the card runs, on the same copy, writing the same line
       property (decision 04-Q31). A second dialog on top of this one is fine:
       both go through showDialog, and showModal() stacks in the top layer. */
    if (anyway && form) {
      anyway.addEventListener('click', function () { qvSmall(box, idInput, anywayGo); });
      var anywayGo = function () {
        var letter = card ? card.getAttribute('data-sts-bar') : null;
        var productId = box.getAttribute('data-product-id');
        function prompted(action) {
          track('sts_buy_anyway_prompt', {
            action: action, surface: 'quick_view', letter: letter, product_id: productId
          });
        }
        prompted('shown');
        var text = reasonSlot ? (reasonSlot.textContent || '') : '';
        confirmDialog(text.trim(), function () {
          prompted('confirm');
          var prop = $('[data-sts-qv-not-for-type]', dlg);
          if (prop && !prop.value) nft(prop, myType() || '');
          addToCart(form, anyway, 'buy_anyway').then(qvClose);
        }, function () { prompted('dismiss'); }, verdict === 'subtype');
      };
    }
  }

  /* v6.3 §3: a smaller size asks before either add (assets/sts-small-size.js,
     fetched on the first add: the fragment's own scripts never run). */
  function qvSmall(box, idInput, go) {
    var j = $('[data-sts-small]', box), S = w.STS && w.STS.smallSize, id = idInput && idInput.value;
    if (S || !j) return S ? S.guard(box, id, go) : go();
    var s = d.createElement('script');
    s.src = j.getAttribute('data-sts-small');
    s.onload = function () { var T = w.STS && w.STS.smallSize; if (T) T.guard(box, id, go); else go(); };
    s.onerror = go;
    d.head.appendChild(s);
  }

  function qvOpen(link, card) {
    var href = link.getAttribute('href');
    if (!href) return;
    var url = href.split('#')[0];
    url += (url.indexOf('?') === -1 ? '?' : '&') + 'view=sts-quick-view';

    /* Engines without showModal() leave a closed <dialog> in the document (see
       hideDialog), so sweep before adding rather than stacking one per click. */
    $$('.sts-modal--qv').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });

    var dlg = d.createElement('dialog');
    dlg.className = 'sts-modal sts-modal--qv';
    /* Named "Quick view" only until the product arrives; the fragment carries
       an <h2 id="sts-qv-title"> and that becomes the name below. A dialog with
       no accessible name reaches a screen reader as "dialog". */
    dlg.setAttribute('aria-label', 'Quick view');
    dlg.innerHTML =
      '<div class="sts-qv__shell">' +
      '<button type="button" class="sts-qv__close" data-sts-qv-close aria-label="Close">&#215;</button>' +
      '<div class="sts-qv__content"><p class="sts-qv__loading" role="status">Loading&hellip;</p></div>' +
      '</div>';
    d.body.appendChild(dlg);
    qvDialog = dlg;

    $('[data-sts-qv-close]', dlg).addEventListener('click', qvClose);
    /* A click that lands on the <dialog> itself landed on the backdrop: the
       shell fills the element, so nothing else can be the target. */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) qvClose(); });
    dlg.addEventListener('close', function () {
      qvDialog = null;
      if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
    });
    /* Opened before the fetch, not after: on a slow connection a button that
       does nothing for two seconds reads as broken, and showModal() is also
       what moves focus off the card and into the dialog. */
    showDialog(dlg);

    function fill(html) {
      /* Closed while it was loading — do not yank focus back to a dead node. */
      if (qvDialog !== dlg) return;
      var content = $('.sts-qv__content', dlg);
      content.innerHTML = html;
      qvWire(dlg, card);
      if ($('#sts-qv-title', dlg)) {
        dlg.setAttribute('aria-labelledby', 'sts-qv-title');
        dlg.removeAttribute('aria-label');
      }
    }

    if (qvCache[url]) { fill(qvCache[url]); return; }

    fetchWithTimeout(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) { qvCache[url] = html; fill(html); })
      .catch(function (err) {
        /* §6.9 event 35. Then hand the shopper the page the link always went
           to — the popup is the shortcut, never the only way through. */
        failed('collection_quick_view', err, function () { qvClose(); w.location.assign(href); });
      });
  }

  /* One listener on the document, not one per card and not one per collection
     root: cards are replaced wholesale by every Section Rendering swap and by
     Load more, and they also appear in product rows and the brand sale row,
     which load this file without a [data-sts-collection] root around them. */
  function wireQuickView() {
    d.addEventListener('click', function (e) {
      /* Every way a shopper can say "not here, in a new tab" is left alone. */
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('[data-sts-quick-view]');
      if (!link) return;
      e.preventDefault();
      var card = link.closest('[data-sts-card]');
      settle(card);
      qvOpen(link, card);
    });
  }

  /* moved: asset-notes/sts-collection.md ("Add to cart and Buy anyway, deleg") */
  function wireCardForms() {
    d.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t && t.closest && t.closest('[data-sts-card-form] button');
      var form = btn && btn.form;
      if (!form || e.defaultPrevented || form.__stsWired) return;
      var add = btn.classList.contains('sts-card__add');
      if (!add && !btn.hasAttribute('data-sts-anyway')) return;
      e.preventDefault();
      if (add) {
        if (!btn.hasAttribute('aria-busy')) addToCart(form, btn);
        return;
      }
      var card = form.closest('[data-sts-card]');
      settle(card);
      var reason = card ? ($('[data-sts-reason]', card) || {}).textContent : '';
      /* §6.9 event 13. `letter` is the barred letter, never the type. */
      function prompted(action) {
        track('sts_buy_anyway_prompt', {
          action: action, surface: 'collection_card',
          letter: card ? card.getAttribute('data-sts-bar') : null,
          product_id: card ? card.getAttribute('data-product-id') : null
        });
      }
      prompted('shown');
      confirmDialog((reason || '').trim(), function () {
        prompted('confirm');
        var prop = $('[data-sts-not-for-type]', form);
        if (prop && !prop.value) nft(prop, myType() || '');
        addToCart(form, btn, 'buy_anyway');
      }, function () { prompted('dismiss'); }, !!card && card.getAttribute('data-sts-fit') === 'subtype');
    });
  }

  /* ------------------------------------------------------------- density */
  /* Always {d, m}: asset-notes/sts-collection.md (density) */
  function readDensity() {
    var v = ls.get('sts_grid_density');
    try { v = JSON.parse(v); } catch (e) { /* bare value */ }
    if (v && typeof v === 'object') return { d: v.d, m: v.m };
    return /^[1-5]$/.test(v) ? { d: String(v) } : null;
  }
  function applyDensity(root) {
    var grid = $('[data-sts-grid]', root);
    var saved = readDensity();
    /* No control (show_density off): the template's columns, no stored pick. */
    var box = $('[data-sts-density]', root);
    if (!box || !grid) return;
    if (saved) {
      if (saved.d) grid.setAttribute('data-density-desktop', String(saved.d));
      if (saved.m) grid.setAttribute('data-density-mobile', String(saved.m));
    }
    $$('.sts-density__btn', box).forEach(function (btn) {
      var axis = btn.getAttribute('data-axis');
      var attr = axis === 'd' ? 'data-density-desktop' : 'data-density-mobile';
      var on = grid.getAttribute(attr) === btn.getAttribute('data-density');
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* The below-grid copy is the closed "More about" accordion now (v6.1 §14,
     assets/sts-page-content.js), so the phone reading clamp is gone. */

  /* Card (i) reason popover: its handler is in assets/sts-ui.js (loaded site-wide). */

  /* ------------------------------------------------ approved-only default */
  /* On for a typed shopper at every new page view; "off" holds for this page
     address (Luis, 2026-09-29, replaces 04-Q11). The rules and the pre-paint
     half: snippets/sts-fits-hold.liquid, which builds this same key. */
  function fitsKey() {
    var p = w.location.pathname;
    var q = /\/search$/.test(p) ? (new URLSearchParams(w.location.search).get('q') || '').trim().toLowerCase() : '';
    return 'sts_fits_off:' + p + (q ? '?' + q : '');
  }
  function hasFits(s) { return /baumann_skin_type/.test(s || ''); }

  /* The toggle's own link when it is due, once per page view so it cannot
     loop; '' when not. */
  var fitsTried = {}, stockTried = {};
  var AUTO = { replace: true, keepScroll: true, auto: true };
  function fitsAuto(root) {
    var filters = $('[data-sts-filters]', root), k = fitsKey();
    var toggle = filters && $('[data-sts-fits-toggle]', filters);
    var href = toggle && toggle.getAttribute('href');
    if (!href || !myType() || fitsTried[k] || filters.hasAttribute('data-fits-active') ||
        filters.getAttribute('data-fits-default') !== '1' || ss.get(k) === '1') return '';
    fitsTried[k] = 1;
    return href;
  }

  /* ----------------------------------------------------------- wiring up */
  function wire(root) {
    var reasons = json($('[data-sts-reasons]', root));
    resolveCards(root, reasons);
    personalise(root);
    applyDensity(root);

    var filters = $('[data-sts-filters]', root);

    if (filters && filters.hasAttribute('data-fits-active')) ss.set(fitsKey(), '0');
    var go = fitsAuto(root);

    /* Default "In stock": asset-notes/sts-collection.md ("in-stock default").
       Due with approved-only, it rides the same swap: ONE result, so a held
       grid is shown once, and on the final count (QA on #701). */
    if (filters) {
      var stockOn = filters.hasAttribute('data-instock-active');
      var stockOpt = $('[data-sts-instock]', filters);
      if (stockOpt) {
        if (stockOn) ss.set('sts_instock_only', '1');
        if (!stockOn && ss.get('sts_instock_only') === null &&
            filters.getAttribute('data-instock-default') === '1') {
          ss.set('sts_instock_only', '1');
        }
        var sHref = stockOpt.getAttribute('href');
        var sGuard = w.location.pathname;
        if (!stockOn && sHref && ss.get('sts_instock_only') === '1' && !stockTried[sGuard]) {
          stockTried[sGuard] = 1;
          if (go) {
            var u = new URL(go, w.location.href);
            u.searchParams.append(stockOpt.getAttribute('data-param') || 'filter.v.availability', stockOpt.getAttribute('data-value') || '1');
            go = u.pathname + u.search;
          } else go = sHref;
        }
      }
    }
    if (go) { applyUrl(root, go, AUTO); return; }

    /* Every default has landed: show the grid (snippets/sts-fits-hold.liquid). */
    root.removeAttribute('data-fits-hold');

    /* The Filters button, its panel's options and its close are delegated in
       assets/sts-filter-panel.js, through STS.coll below. */

    /* Both locked pills (phone and desktop copies, COL-3) open the one modal. */
    var locks = $$('[data-sts-lock]', root);
    var unlock = $('[data-sts-unlock]', root);
    if (locks.length && unlock) {
      locks.forEach(function (lock) { lock.addEventListener('click', function () { showDialog(unlock); }); });
      var dismiss = $('[data-sts-modal-close]', unlock);
      if (dismiss) dismiss.addEventListener('click', function () { hideDialog(unlock); });
    }

    $$('[data-sts-density] .sts-density__btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grid = $('[data-sts-grid]', root);
        if (!grid) return;
        var axis = btn.getAttribute('data-axis');
        var val = btn.getAttribute('data-density');
        grid.setAttribute(axis === 'd' ? 'data-density-desktop' : 'data-density-mobile', val);
        var saved = readDensity() || {};
        saved[axis] = val;
        ls.set('sts_grid_density', JSON.stringify(saved));
        applyDensity(root);
      });
    });

    /* Chips for whatever the server could not see (the zero-result case), drawn
       before the links below are bound so they are bound with everything else. */
    syncChips(root);

    /* Chip, toggle, clear and page links all stay real <a href>s; this only
       intercepts the click so the swap is a fetch instead of a navigation.
       Taking approved-only or In stock off is recorded in applyUrl. */
    $$('[data-sts-clear], [data-sts-fits-toggle], [data-sts-fits-off], .sts-pager__link[href], .sts-chip[href]', root)
      .forEach(function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href');
          if (!href || e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;
          e.preventDefault();
          if (link.hasAttribute('data-sts-clear')) href = keepFits(root, href);
          applyUrl(root, href);
        });
      });

    var sort = $('[data-sts-sort]', root);
    if (sort) {
      var sel = $('select', sort);
      /* This URL's own filters, not the form's hidden copies (the no-JS path):
         those carry a price in cents (min_value.value), 100x the band. */
      if (sel) sel.addEventListener('change', function () {
        var u = new URL(w.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        applyUrl(root, u.pathname + u.search);
      });
    }

    var more = $('[data-sts-loadmore]', root);
    if (more) {
      more.addEventListener('click', function () {
        var pager = $('[data-sts-pager]', root);
        var next = pager && pager.getAttribute('data-next-url');
        if (!next || busy) return;
        busy = true;
        more.setAttribute('aria-busy', 'true');
        fetchWithTimeout(sectionUrl(next, root.getAttribute('data-section-id')), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = $('[data-sts-grid]', root);
            var freshGrid = doc.querySelector('[data-sts-grid]');
            var freshPager = doc.querySelector('[data-sts-pager]');
            if (grid && freshGrid) {
              var added = Array.prototype.slice.call(freshGrid.children);
              added.forEach(function (n) { grid.appendChild(n); });
              resolveCards(root, reasons);
              personalise(root);
              if (added.length && added[0].querySelector) {
                var focusTarget = added[0].querySelector('a[href]');
                if (focusTarget) focusTarget.setAttribute('tabindex', '-1');
              }
            }
            if (freshPager && freshPager.getAttribute('data-next-url')) {
              pager.setAttribute('data-next-url', freshPager.getAttribute('data-next-url'));
            } else {
              more.parentNode.removeChild(more);
            }
            busy = false;
            more.removeAttribute('aria-busy');
          })
          .catch(function (err) {
            busy = false;
            more.removeAttribute('aria-busy');
            failed('collection_load_more', err, function () { w.location.assign(next); });
          });
      });
    }
  }

  /* §6.9 events 8, 9 and the collection's quiz links. Delegated on the root,
     which survives every Section Rendering swap (only its children are
     replaced), so it is bound once here rather than on every wire(). It only
     observes; the handlers in wire() do the work. */
  function wireTracking(root) {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var collection = collectionHandle();

      if (t.closest('[data-sts-lock]')) {
        track('sts_locked_filter_tap', { surface: 'filter_bar', action: 'open', collection: collection });
        return;
      }

      var unlock = t.closest('[data-sts-unlock]');
      if (unlock) {
        var link = t.closest('a[href]');
        if (link) {
          track('sts_locked_filter_tap', { surface: 'lock_modal', action: 'quiz', collection: collection });
          quizClick('lock_modal', link.getAttribute('href'));
        } else if (t.closest('[data-sts-modal-close]')) {
          track('sts_locked_filter_tap', { surface: 'lock_modal', action: 'dismiss', collection: collection });
        }
        return;
      }

      var toggle = t.closest('[data-sts-fits-toggle]');
      if (toggle) {
        if (!toggle.getAttribute('href')) return;
        var turningOn = !toggle.classList.contains('is-on');
        var counts = json(root, 'data-type-counts');
        var type = myType();
        track('sts_approved_only_toggle', {
          on: turningOn,
          collection: collection,
          results_count: turningOn && counts && type && typeof counts[type] === 'number' ? counts[type] : null
        });
        return;
      }

      var a = t.closest('a[href]');
      if (a) quizClick('collection', a.getAttribute('href'));
    });
  }

  /* window.STS.onState is workstream 02's subscribe helper. Subscribing rather
     than reading once means the cards are re-resolved if the state changes
     later — a sign-in, an attached quiz result, or the staff state simulator —
     instead of this file racing the resolver and losing on a slow device. */
  /* Cards outside a collection root (home rows, sale row) are resolved here
     too, now and on every state change, or a guest's barred card shows the
     CSS pill over an empty reason line until something is clicked. */
  function resolveLoose() { resolveCards(d, json($('[data-sts-reasons]'))); }

  function boot() {
    if (w.STS && typeof w.STS.onState === 'function') w.STS.onState(resolveLoose);
    resolveLoose();
    $$('[data-sts-collection]').forEach(function (root) {
      wireTracking(root);
      wire(root);
      w.addEventListener('popstate', function () {
        applyUrl(root, w.location.pathname + w.location.search, { replace: true });
      });
      if (w.STS && typeof w.STS.onState === 'function') {
        var first = true;
        w.STS.onState(function () {
          if (first) { first = false; return; }
          resolveCards(root, json($('[data-sts-reasons]', root)));
          personalise(root);
          /* A late type (the simulator's first page) turns it on too. */
          var late = !busy && fitsAuto(root);
          if (late) applyUrl(root, late, AUTO);
        });
      }
    });
  }

  /* Every card on the page, not only the collection grid: product rows and the
     brand sale row load this file but have no [data-sts-collection] root.
     Subscribed now, not in boot(), because sts:profile:ready fires at
     DOMContentLoaded; onProfile also re-flags on a Skin Profile save. */
  if (w.STS && typeof w.STS.onProfile === 'function') {
    w.STS.onProfile(function () { flagCards(d); });
  } else {
    d.addEventListener('sts:profile:ready', function () { flagCards(d); });
  }

  /* Outside boot() on purpose: this is a delegated listener on the document,
     so it does not need the DOM to be finished and it must be live for cards
     that are nowhere near a collection root. */
  wireQuickView();
  wireCardForms();

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})(window, document);
